import React, { useContext } from 'react'

import {
    Box,
    Flex,
    HStack,
    Button,
    Text,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Stack,
    Icon,
    IconButton,
    useDisclosure,
    useColorModeValue,
} from '@chakra-ui/react';
// Here we have used react-icons package for the icons
import { GiHamburgerMenu } from 'react-icons/gi';
import { AiOutlineClose } from 'react-icons/ai';
import { BiChevronDown } from 'react-icons/bi';
import { ColorModeSwitcher } from "../ColorModeSwitcher";

import { Link } from "react-router-dom"
import { LoginContext } from '../context/LoginContext';

const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Collections', path: '/collections' },
    { name: 'New Collection', path: '/newCollection' }
];

const dropdownLinks = [
    {
        name: 'Blog',
        path: '#'
    },
];

// no d => como display porque no funciona

export const AppBar = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { user, setUser } = useContext(LoginContext)

    const handleLogaut = () => {
        localStorage.clear("user");
        setUser(null)
    }
    return (
        <Box px={4} bg={useColorModeValue('white', 'gray.800')}>
            <Flex h={16} alignItems="center" justifyContent="space-between" mx="auto">
                <Text className='logo' color="#63b3ed">
                    Web Collections
                </Text>
                <HStack spacing={8} alignItems="center">
                    <HStack as="nav" spacing={6} display={{ base: 'none', md: 'flex' }} alignItems="center">
                        {navLinks.map((link, index) => (
                            <NavLink key={index} {...link} onClose={onClose} />
                        ))}

                        {/* Dropdown Menu */}
                        <Menu autoSelect={false} isLazy>
                            {({ isOpen, onClose }) => (
                                <>
                                    <MenuButton _hover={{ color: 'blue.400' }}>
                                        <Flex alignItems="center">
                                            <Text>Community</Text>
                                            <Icon
                                                as={BiChevronDown}
                                                h={5}
                                                w={5}
                                                ml={1}
                                                transition="all .25s ease-in-out"
                                                transform={isOpen ? 'rotate(180deg)' : ''}
                                            />
                                        </Flex>
                                    </MenuButton>
                                    <MenuList
                                        zIndex={5}
                                        bg="none"
                                        border="1px solid #ccc"
                                        boxShadow="md"
                                    >
                                        {dropdownLinks.map((link, index) => (
                                            <MenuLink key={index} name={link.name} path={link.path} onClose={onClose} />
                                        ))}
                                    </MenuList>
                                </>
                            )}
                        </Menu>
                        <ColorModeSwitcher />
                    </HStack>
                </HStack>

                <Button
                    onClick={handleLogaut}
                    colorScheme="blue"
                    variant='outline'
                    size="md"
                    rounded="md"
                    display={{ base: 'none', md: 'block' }}>
                    Logaut
                </Button>
                <IconButton
                    size="md"
                    icon={isOpen ? <AiOutlineClose /> : <GiHamburgerMenu />}
                    aria-label="Open Menu"
                    display={{ base: 'inherit', md: 'none' }}
                    onClick={isOpen ? onClose : onOpen}
                />
            </Flex>

            {/* Mobile Screen Links */}
            {isOpen ? (
                <Box pb={4} d={{ base: 'inherit', md: 'none' }}>
                    <Stack as="nav" spacing={2}>
                        {navLinks.map((link, index) => (
                            <NavLink key={index} {...link} onClose={onClose} />
                        ))}
                        <Text fontWeight="semibold" color="gray.500">
                            Community

                        </Text>
                        <Stack pl={2} spacing={1} mt={'0 !important'}>
                            {dropdownLinks.map((link, index) => (
                                <NavLink key={index} {...link} onClose={onClose} />
                            ))}
                        </Stack>
                    </Stack>
                </Box>
            ) : null}
        </Box>
    );
}



const NavLink = ({ name, path, onClose }) => {
    return (
        <Link
            to={path}
        >
            <Text lineHeight="inherit"
                _hover={{
                    textDecoration: 'none',
                    color: useColorModeValue('blue.500', 'blue.200')
                }}
                onClick={() => onClose()}
            >
                {name}

            </Text>
        </Link>
    );
};



const MenuLink = ({ name, path, onClose }) => {
    return (
        <Link to={path}>
            <MenuItem
                onClick={() => onClose()}
                _hover={{ color: 'blue.400', bg: useColorModeValue('gray.200', 'gray.700') }}
            >
                <Text >{name}</Text>
            </MenuItem>
        </Link>
    );
};